class infoDrawer extends HTMLElement {
  constructor() {
    super()
    this.selectors = {
      openButton: '[data-openmodal]',
      content: '.m-infodrawer--content .m-collapsible--content__inner',
      container: '.m-product-infodrawer'
    }
  }

  connectedCallback() {
    this.domNodes = queryDomNodes(this.selectors,this);
    this.container = document.querySelector(this.selectors.container);
    this.colorScheme = this.domNodes.content.dataset.colorScheme;
    if (this.domNodes.content && this.domNodes.content.innerHTML) {
      this.content = this.domNodes.content.innerHTML;
      this.init();
    }
  }

  init() {
    this.modal = new MinimogTheme.Modal();
    addEventDelegate({
      selector: this.selectors.openButton,
      handler: (e) => {
        e.preventDefault()
        if (this.content) {
          this.modal.removeChild();
          const html = document.createElement("DIV");
          html.classList.add('rte');
          html.innerHTML = this.content;
          this.modal.appendChild(html);
          this.modal.setWidth('33.333333%');
          this.modal.setSizes(`m-info-drawer m-gradient ${this.colorScheme}`);
          //this.modal.open();
        }
      }
    });
    this.domNodes.openButton.addEventListener("click", this.openModal.bind(this));
  }

  openModal(event) {
    console.log(event)
    this.modal.open();
  }

}
customElements.define('info-drawer', infoDrawer)

function openReviews(){
  let tagHTML = document.querySelector("html");
  let modalReview = document.querySelector("#jdgmModal");
  tagHTML.classList.add("prevent-scroll");
  modalReview.classList.add("m-open-modal");
}
function closeReviews(){
  let tagHTML = document.querySelector("html");
  let modalReview = document.querySelector("#jdgmModal");
  tagHTML.classList.remove("prevent-scroll");
  modalReview.classList.remove("m-open-modal");
}
document.addEventListener('DOMContentLoaded', function() {
  
  const modalReview = document.querySelector("#jdgmModal");
  if(Boolean(modalReview)){
    
  
  modalReview.addEventListener("click", e=>{
    e.preventDefault();
    e.stopPropagation();
    closeReviews();
  });
  modalReview.querySelector(".m-modal--content").addEventListener("click", e=>{
    e.preventDefault();
    e.stopPropagation();
  });
  
  let modalClose = document.querySelector("#jdgmModal .m-modal--close");
  modalClose.addEventListener("click", e=>{
    e.preventDefault();
    closeReviews();
  });
  }

  /*const filters = document.querySelectorAll(".m-filter--widget.m-accordion--item .m-accordion--item-button");
  filters.forEach(fiteritem=>{
    fiteritem.addEventListener("click",e=>{
      document.querySelectorAll("#CollectionFiltersForm .m-accordion--item.open").forEach(ele=>{
        if(ele!=fiteritem.parentElement){
          ele.classList.remove("open");
          ele.style.setProperty("--content-max-height", 0);
          ele.querySelector(".m-filter--widget-content.m-accordion--item-content").classList.add("m:overflow-hidden");
        }
        
      });
      
    });
  });*/
  
});
